export default "__VITE_ASSET__DWFKOWSU__"